import { render, staticRenderFns } from "./ProgrammaticTargetRequestSettings.vue?vue&type=template&id=077d6385"
import script from "./ProgrammaticTargetRequestSettings.vue?vue&type=script&lang=js"
export * from "./ProgrammaticTargetRequestSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports